import * as React from 'react';

class PrinterSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon printer-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M24 12H22V2C22 1.46957 21.7893 0.96086 21.4142 0.585787C21.0391 0.210714 20.5304 0 20 0H6C5.46957 0 4.96086 0.210714 4.58579 0.585787C4.21071 0.96086 4 1.46957 4 2V12H2C1.46957 12 0.96086 12.2107 0.585787 12.5858C0.210714 12.9609 0 13.4696 0 14V23C0 23.5304 0.210714 24.0391 0.585787 24.4142C0.96086 24.7893 1.46957 25 2 25H24C24.5304 25 25.0391 24.7893 25.4142 24.4142C25.7893 24.0391 26 23.5304 26 23V14C26 13.4696 25.7893 12.9609 25.4142 12.5858C25.0391 12.2107 24.5304 12 24 12ZM6 2H20V12H6V2ZM24 23H2V14H24V23ZM20.5 18C20.7967 18 21.0867 18.088 21.3334 18.2528C21.58 18.4176 21.7723 18.6519 21.8858 18.926C21.9993 19.2001 22.0291 19.5017 21.9712 19.7926C21.9133 20.0836 21.7704 20.3509 21.5607 20.5607C21.3509 20.7704 21.0836 20.9133 20.7926 20.9712C20.5017 21.0291 20.2001 20.9993 19.926 20.8858C19.6519 20.7723 19.4176 20.58 19.2528 20.3334C19.088 20.0867 19 19.7967 19 19.5C19 19.1022 19.158 18.7206 19.4393 18.4393C19.7206 18.158 20.1022 18 20.5 18ZM8 8H18V10H8V8ZM8 4H18V6H8V4Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default PrinterSvg;
